IREP.fivestarold = (function () {
    var init = function () {
        $('#fivestar .menu li.stores > a').on('click', function (e) {
            e.preventDefault();
            $(this).closest('li').find('ul').slideToggle();
        });

        $('#fivestar .qualifications').on('click', '.nav > div > div', function () {
            var $root = $(this).closest('.qualifications');

            var tab = $(this).data('tab');
            $(this).siblings().removeClass('selected');
            $(this).addClass('selected');
            $root.find('.tabcontent').hide();
            $root.find('.' + tab).show();

            $root.find('.more').hide();
            $root.find('.less').show();
        });

        $('#fivestar .qualifications').on('click', '.header span', function () {
            var $root = $(this).closest('.qualifications');
            var tab = $root.find('.selected').data('tab');

            $root.find('.' + tab).toggle();
            $root.find('.more').toggle();
            $root.find('.less').toggle();
        });

        if ($('#fivestar .stream').length > 0) {
            var hub = new IREP.FiveStarHub({ 'paxuid': IREP.options.user.currentUID });
        }

        $('#fivestar a[data-achievement]').on('click', function (e) {
            e.preventDefault();
            var $giveKudos = $(this);
            var achievementUID = $(this).data('achievement');
            var $kudos = $(this).siblings('.kudos');
            IREP.callApi({ type: 'POST', url: 'fivestar/achievement/kudos', data: { uid: achievementUID } }).done(function (result) {
                if (result.kudos === true) {
                    var $img = $('<img/>', { src: IREP.options.apiUrl + 'participant/profile/' + IREP.options.user.currentUID });
                    $kudos.append($img);
                    $giveKudos.remove();
                }
            });
        });

        $('#fivestar .addComment a').on('click', function (e) {
            e.preventDefault();

            var achievementUID = $(this).closest('[data-achievement]').data('achievement');
            var text = $(this).siblings('input').val();

            addComment(achievementUID, text);
        });

        $('#fivestar .addComment input').on('keypress', function (e) {
            if (e.which === 13) {
                var achievementUID = $(this).closest('[data-achievement]').data('achievement');
                var text = $(this).val();

                addComment(achievementUID, text);
            }
        });

        $('#fivestar [data-tooltip-text]').on('click', function (e) {
            $('.tooltip').remove();
            var title = $(this).data('tooltip-title');
            var text = $(this).data('tooltip-text');
            var position = $(this).data('tooltip-position');

            var offset = $(this).offset();
            var $body = $('body');
            var $div = $('<div class="tooltip"><div class="close"></div><h1>' + title + '</h1><p>' + text + '</p></div>');
            
            $body.append($div);
            if (position === "right") {
                $div.offset({ left: offset.left - $div.width() - 5, top: offset.top - $div.height() - 25 });
            } else {
                $div.offset({ left: offset.left, top: offset.top - $div.height() - 25 });
            }

            $div.find('.close').on('click', function () {
                $('.tooltip').remove();
            });
        });
    };

    var addComment = function (achievementUID, text) {
        IREP.callApi({ type: 'POST', url: 'fivestar/achievement/comment', data: { uid: achievementUID, text: text } }).done(function (result) {
            $('#fivestar .addComment[data-achievement=\'' + achievementUID + '\'] input').val('');
            window.location = window.location;
        });
    };

    return {
        init: init
    };
}());

IREP.fivestarold.quickpoll = (function () {
    var submitButton;
    var sidebarH2;
    var init = function (options) {

        var qpData = {};
        qpData.Code = options.quizCode;
        qpData.CultureCode = IREP.options.user.cultureCode;
        qpData.CountryCode = IREP.options.user.countryCode;
        qpData.SQuestions = options.hfQuestions;
        qpData.StoreChainId = options.storeChainId;
        submitButton = options.submitButton;

        $(options.submitButton).click(function () {
            if (typeof $("input:checked").val() != "undefined") {//force them to make a selection to submit
                qpData.AnswerCode = $("input:checked").val(); //get which radio button checked
                qpData.AnswerText = "";
                qpData.ActivityTime = options.hfTimeStamp;
                $(submitButton).css("display", "none"); //hide submit button
                $(options.divSubmit).css("margin-left", "30px");
                $(options.divSubmit).html("Retrieving results...");
                IREP.callApi("quiz/quickpollsubmit", "POST", qpData).done(function (data) {
                });
            }
            else { return false;}

        });
    };

    return {
        init: init
    };
})();


